import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { certificates } from "../data.js";
import { localizeDateLabel, localizeField } from "../i18n.js";
import { getCertificateSlug } from "./CertificatesPage.jsx";

export default function CertificateDetail({ t, copy, language }) {
  const { certificateId } = useParams();
  const [imageFailed, setImageFailed] = useState(false);
  const certificate = certificates.find(
    (cert) => getCertificateSlug(cert) === certificateId
  );

  useEffect(() => {
    setImageFailed(false);
  }, [certificateId]);

  if (!certificate) {
    return <div style={{ color: t.dim }}>{copy.certificateNotFound}</div>;
  }

  const imageSrc =
    certificate.image || `/img/certificates/${getCertificateSlug(certificate)}.jpg`;

  return (
    <article>
      <Link
        to="/certificates"
        style={{
          color: t.dim,
          display: "inline-block",
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 12,
          marginBottom: 20,
          textDecoration: "none",
        }}
      >
        {copy.backCertificates}
      </Link>

      <h2 style={{ color: t.text, fontSize: 23, fontWeight: 400, margin: "0 0 8px" }}>
        {localizeField(certificate, "title", language)}
      </h2>

      <div style={metaStyle}>
        <span style={{ color: t.dim }}>{localizeField(certificate, "issuer", language)}</span>
        {certificate.issued ? (
          <span style={{ color: t.dim }}>
            {localizeDateLabel(certificate.issued, language)}
          </span>
        ) : null}
        {certificate.id ? <span style={{ color: t.dim }}>ID: {certificate.id}</span> : null}
      </div>

      {!imageFailed ? (
        <a href={imageSrc} target="_blank" rel="noopener noreferrer">
          <img
            alt={`${localizeField(certificate, "title", language)} ${copy.certificateAltSuffix}`}
            onError={() => setImageFailed(true)}
            src={imageSrc}
            style={{
              background: t.surface2,
              border: `1px solid ${t.borderLight}`,
              borderRadius: 8,
              display: "block",
              height: "auto",
              maxWidth: "100%",
            }}
          />
        </a>
      ) : (
        <p style={{ color: t.dim, fontSize: 14, margin: 0 }}>
          {copy.certificateImageMissing}
        </p>
      )}
    </article>
  );
}

const metaStyle = {
  display: "flex",
  flexWrap: "wrap",
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 12,
  gap: 20,
  marginBottom: 28,
};
